import I18n from '@/rI18n';
import { tr } from '@/common/utils/tr';

/**
 * tr() for strings that come from the Amplify I18n vocabulary.
 *
 */
export function trI18n(key) {
    if (typeof key !== 'string' || key.length === 0) {
        return key;
    }

    const sourceText = I18n.get(key);
    return sourceText === key ? key : tr(sourceText);
}

export default trI18n;
